import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_HORIZON_STAT,
  DELETE_HORIZON_STAT,
  GET_HORIZON_STATS,
  UPDATE_HORIZON_STAT
} from '../actions';

export function horizonStatListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_HORIZON_STAT:
      const match = state.find(horizonStat => action.payload.horizonStat && horizonStat.id === action.payload.horizonStat.id);
      return !match
        ? [ ...state, action.payload.horizonStat ]
        : state;
    case DELETE_HORIZON_STAT:
      return state.filter(horizonStat => horizonStat.id !== action.payload.id);
    case GET_HORIZON_STATS:
      return action.payload.horizonStats;
    case UPDATE_HORIZON_STAT:
      return state.map(horizonStat => {
        return horizonStat.id === action.payload.horizonStat.id
          ? action.payload.horizonStat
          : horizonStat;
      });
    default:
      return state;
  }
}

export const horizonStatReducers = combineReducers({
  horizonStatList: horizonStatListReducer
});


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/horizonStats.ts